import { cn } from "@/lib/utils";

import {
  FRAMING_SECTION_FILTER_LABELS,
  type FramingSectionFilter,
  type FramingSectionModel,
} from "./framingSectionModel";

/**
 * Summary counts as clickable filters (CROP-WB-005). Every chip is a real
 * toggle button with an accessible pressed state, not a decorative badge.
 */
export function FramingSummaryBar({
  model,
  filter,
  onFilterChange,
}: {
  model: FramingSectionModel;
  filter: FramingSectionFilter;
  onFilterChange: (filter: FramingSectionFilter) => void;
}) {
  const entries = (
    Object.keys(FRAMING_SECTION_FILTER_LABELS) as FramingSectionFilter[]
  ).filter((key) => key === "all" || model.counts[key] > 0);
  return (
    <div
      className="flex flex-wrap items-center gap-2"
      role="group"
      aria-label="Framing scene filters"
    >
      {entries.map((key) => {
        const selected = filter === key;
        return (
          <button
            key={key}
            type="button"
            aria-pressed={selected}
            onClick={() => onFilterChange(selected ? "all" : key)}
            className={cn(
              "rounded-full border px-3 py-1 text-xs transition-colors",
              selected
                ? "border-primary bg-primary text-primary-foreground"
                : "bg-background text-muted-foreground hover:bg-muted",
            )}
          >
            {FRAMING_SECTION_FILTER_LABELS[key]}
            <span className="ml-1 font-mono">{model.counts[key]}</span>
          </button>
        );
      })}
    </div>
  );
}
